__turbopack_context__.v({
  "className": "montserrat_c1922a4a-module__oddQCW__className",
  "variable": "montserrat_c1922a4a-module__oddQCW__variable",
});
